import { useCallback } from "react";
import useRequest from "./useRequest";
import { API_CONNECTED_OBJECT, API_INACTIVE, BASE_ADMIN } from "../constants/api";

type InactiveResponse = {
  connectedObjects: {id: number, url: string}[]
}

export default function useInactiveObj() {
  const {request, response, error} = useRequest<InactiveResponse>();

  const get = useCallback(() => {
    const searchParams = {limit: "4"}
    request(BASE_ADMIN, `${API_CONNECTED_OBJECT}/${API_INACTIVE}`, {secure: true, searchParams})
  }, [request])

  
  const search = useCallback((url: string) => {
    const searchParams = {limit: "4", search: url}
    request(BASE_ADMIN, `${API_CONNECTED_OBJECT}/${API_INACTIVE}`, {secure: true, searchParams})
  }, [request])

  return {get, search, data: response?.connectedObjects, error}
}